import React, { Component } from 'react';
import './App.css';

import AboutMe from './AboutMe';
import Publications from './Publications';
import Other from './Other';
import Posters from './Posters';
import Contact from './Contact';

class App extends Component {
  render() {
    return (
      <div>
      <div className="navbar navbar-default" role="navigation">
        <div className="container-fluid">
          <div className="collapse navbar-collapse" id="nav">
            <ul className="nav navbar-nav  navbar-center">
              <li className="active"><a href="#about">ABOUT ME</a></li>
              <li><a href="#pubs">PUBLICATIONS</a></li>
              <li><a href="#about">PROJECTS</a></li>
              <li><a href="#other">OTHER</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container-fluid">
      <div className="gsp-main" >
        <AboutMe  />
        <Publications />
        <Posters />
        <Other />
      </div>
  </div>

    <footer>
      <Contact />
        last update: May, 2018 &nbsp;&nbsp;&nbsp;&nbsp;
          ©  <a href="#about"> Paola l. Valdivia </a>
    </footer>

    </div>
  );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js